var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-evaluate"},[_c('span',{staticClass:"c-evaluate__header"},[_vm._v("测评效果图")]),_c('div',{staticClass:"c-evaluate__bgc"},[_c('div',{staticClass:"evaluate-effect"})])])
}]

export { render, staticRenderFns }